<script>
import FirstPhone from "@js/components/Sections/Links/FirstPhone.vue";
import SecondPhone from "@js/components/Sections/Links/SecondPhone.vue";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";
import IconEnvelope from "@js/components/Icons/IconEnvelope.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import IconClock from "@js/components/Icons/IconClock.vue";

export default {
    name: "ContactTopInfo",
    components: {IconClock, IconPhone, IconEnvelope, IconMapPoint, SecondPhone, FirstPhone},
}
</script>

<template>
    <div class="mb-10">
        <h1 class="text-3xl md:text-4xl font-bold text-white mb-2">
            Свяжитесь с нами
        </h1>
        <p class="text-md text-white hidden md:block">
            Наши специалисты помогут подобрать продукцию, рассчитать стоимость и оформить доставку – звоните или
            оставьте заявку, и мы свяжемся с вами.
        </p>
    </div>
    <div
        class="border rounded-md border-[#FFFFFF80] backdrop-blur-xl bg-[#2D2D2D]/50 p-8 flex flex-col gap-5 md:gap-10 mb-10">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10">
            <div>
                <IconMapPoint class="text-white w-6 h-6 mb-1"/>
                <p class="text-white font-medium text-lg">
                    Адрес
                </p>
                <a href="https://yandex.com/maps/-/CHqNiWk4" target="_blank"
                   class="text-white hover-white-decor text-sm transition">
                    Домодедово, Промышленная ул. 38
                </a>
            </div>
            <div>
                <IconEnvelope class="text-white w-6 h-6 mb-1"/>
                <p class="text-white font-medium text-lg">
                    Почта
                </p>
                <a href="mailto:sale@dorozhnyeplity.ru" target="_blank"
                   class="text-white hover-white-decor text-sm transition">
                    sale@dorozhnyeplity.ru
                </a>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10">
            <div class="font-medium">
                <IconClock class="text-white w-6 h-6 mb-1"/>
                <p class="text-white text-lg">
                    Режим работы
                </p>
                <p class="text-white text-sm">
                    Пн-Вс: Круглосуточно
                </p>
            </div>
            <div>
                <IconPhone class="text-white w-7 h-7"/>
                <p class="text-white font-medium text-lg">
                    Телефон
                </p>
                <div class="flex items-center gap-5">
                    <FirstPhone class="text-white text-sm hover:text-indigo-600 hover-white-decor transition"/>
                    <SecondPhone class="text-white text-sm hover:text-indigo-600 hover-white-decor transition"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
